import React from 'react'
import ReactDOM from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { initSentry } from '@trinity/utils'

const sentryDsn = 'https://3a4dad958898f431008200b98e18d5ed@o170893.ingest.sentry.io/4506123353456640'
const sentryRelease = `supplier@${__APP_VERSION__}`
initSentry(sentryDsn, sentryRelease)

React.startTransition(() => {
  ReactDOM.hydrateRoot(
    document,
    <React.StrictMode>
      <HydratedRouter />
    </React.StrictMode>,
  )
})
